var React = require('react');

function ArrowAccordion (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M16.5334 10.0938C16.7074 10.0938 16.861 10.0242 16.9934 9.88497C17.1096 9.76274 17.1631 9.61017 17.1546 9.42726C17.147 9.24436 17.0842 9.09179 16.9688 8.96955L9.40969 1.02344C9.2111 0.814657 8.96669 0.709375 8.67645 0.709375C8.3862 0.709375 8.13415 0.814657 7.91859 1.02344L0.359523 8.96955C0.244105 9.10874 0.185547 9.26577 0.185547 9.44064C0.185547 9.61463 0.244105 9.77166 0.359523 9.91084C0.492764 10.0331 0.645524 10.0938 0.8195 10.0938C0.993476 10.0938 1.1386 10.0331 1.25487 9.91084L8.66456 2.12087L16.0734 9.91084C16.2058 10.0331 16.3594 10.0938 16.5334 10.0938Z","fill":"currentColor"}));
}

ArrowAccordion.defaultProps = {"width":"18","height":"11","fill":"none","role":"presentation","aria-hidden":"true","data-contrast":"svg-fill","className":"icon"};

module.exports = ArrowAccordion;

ArrowAccordion.default = ArrowAccordion;
